import axios from 'axios'
import app from '../main'
const API_URL = process.env.NODE_ENV === 'development' ? '/api' : '/api'
const CancelToken = axios.CancelToken
const source = CancelToken.source()
const instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000
})
instance.interceptors.request.use(config => {
  app.$Progress.start()
  return config
}, error => {
  const res = error.response
  if (res && res.statusText) app.toast(res.statusText, {title: 'Error', variant: 'danger'})
  app.$Progress.fail()
  return error
})

instance.interceptors.response.use(response => {
  app.$Progress.finish()
  return response
}, error => {
  return new Promise(async (resolve, reject) => {
    if (error.response === undefined) {
      app.$Progress.fail()
      return reject(error)
    }
    const { config, response: { status } } = error
    const originalRequest = config
    /*
    if (status === 426) {
      await CancelToken.source()
      app.$Progress.fail()
      await app.$store.dispatch('logout')
      app.$router.replace('/login')
      app.toast(statusText, {title: 'Error', variant: 'danger'})
      return resolve()
    }
    */
    if (status === 401) {
      try {
        if (!app.$store.getters.refreshToken) {
          await app.$store.dispatch('logout')
          app.$router.replace('/login')
          await CancelToken.source()
          return resolve()
        }
      } catch (e) {
        console.log(e)
      }
      try {
        console.warn('access token request')
        const {accessToken} = await app.$store.dispatch('accessTokenRequest')
        originalRequest.headers['Authorization'] = `Bearer ${accessToken}`
        originalRequest.baseURL = undefined
        originalRequest.timeout = 8000
        const retry = await axios(originalRequest)
        return resolve(retry)
      } catch (e) {
        app.$Progress.fail()
        const res = error.response
        if (res && res.statusText) app.toast(res.statusText, {title: 'Error', variant: 'danger'})
        app.$router.replace('/login')
        return reject(error)
      }
    } else if (status === 499) { // Refresh Token 실패
      const res = error.response
      if (res && res.statusText) app.toast(`Refresh Token invalid / ${res.statusText}`, {title: 'Error', variant: 'danger'})
      app.$Progress.fail()
      app.$router.replace('/login')
      return reject(error)
    } else {
      const {response} = error
      const {statusText} = response
      if (statusText) {
        app.toast(statusText, {title: 'Error', variant: 'danger'})
      } else {
        const {data} = response
        console.log(response, error)
        app.toast(data, {title: 'Error', variant: 'danger'})
      }
      app.$Progress.fail()
      return reject(error)
      // MARK: 그외 오류 500 등등
    }
  })
})

export const ins = instance
export const src = source
export const CT = CancelToken



// WEBPACK FOOTER //
// ./src/plugin/axios.js